import React from 'react';

import {ButtonDropdown} from '../';

import './styles.css';

const Options = ({
  archived,
  canBeEdited,
  archiveNote,
  restoreNote,
  editNote,
  dropdownClassName
}) => (
  <ButtonDropdown
    title=""
    dropdownClassName={dropdownClassName}
    menuPosition={ButtonDropdown.MENU_POSITION_BOTTOM_LEFT}>
    {!archived &&
      canBeEdited && (
        <ButtonDropdown.Option onClick={editNote}>
          Edit Note
        </ButtonDropdown.Option>
      )}
    {!archived && (
      <ButtonDropdown.Option onClick={archiveNote}>
        Archive Note
      </ButtonDropdown.Option>
    )}
    {archived && (
      <ButtonDropdown.Option onClick={restoreNote}>
        Restore Note
      </ButtonDropdown.Option>
    )}
  </ButtonDropdown>
);

export default Options;
